/*
 * @@Description:
 * @@Author: MuYang
 * @Date: 2021-08-27 10:08:58
 * @LastEditTime: 2021-10-20 20:41:55
 */

import { PREFIX } from './config'
const REGSTRING = /[^.]+/g

// 格式化高度宽度
export function parseUnit (value) {
  if (value === 'auto') {
    return 'auto'
  }
  if (typeof value === 'number') {
    return value
  }
  if (typeof value === 'string') {
    return /^\d+(?:px)?$/.test(value) ? parseInt(value, 10) : value
  }
  return null
}

// 判断是不是对象
export function isObject (value) {
  return Object.prototype.toString.call(value) === '[object object]'
}

// 解析字符串 a.b
export function parseString (str, data) {
  if (typeof str !== 'string') return ''
  const arr = str.match(REGSTRING)
  if (arr.length === 0 || arr.length === 1) return data[str]
  return arr.reduce((a, b) => a[b], data)
}

// 设置className
export function getClassName (column) {
  let className = `${PREFIX}-body-cell`
  if (column.className) {
    className += ` ${column.className}`
  }
  return className
}

// 合并对象
export function assign (target, source) {
  return Object.assign(target, source)
}

let LINE_NUM
export function getLineNum () {
  if (!LINE_NUM) {
    // todo 等待修改后 谷歌改成2
    LINE_NUM = window.navigator.userAgent.includes('Chrome') ? 1 : 1
  }
  return LINE_NUM
}
